<!--面板组件-->

<template>
  <div class="panel" @click="$emit('click')">
    <slot name="title"></slot>
    <img class="icon-right" src="@/assets/pc/icon_arrow down.svg" alt="">
  </div>
</template>

<script>
  export default {
    name: 'PanelTitle',
    props: {}
  }
</script>

<style lang="scss" scoped>
  .panel {
    position: relative;
    width: 776px;
    height: 156px;
    border: 1px solid #EAEEF3;
    border-radius: 8px;
    padding: 22px;
    cursor: pointer;

    .title {
      width: 670px;
      font-family: Nunito-SemiBold;
      font-size: 24px;
      color: #3E8EDE;
      letter-spacing: 0.14px;
      position: absolute;
      top:50%;
      transform: translateY(-50%);
      height: 112px;
      line-height: 112px;
    }

    .icon-right {
      width: 50px;
      position: absolute;
      right: 10px;
      top:50%;
      transform: translateY(-50%) rotate(-90deg);
    }
  }
</style>
